import * as api from '../../../clients/api';

import {Action} from '@ngrx/store';

export const GET_IDENTITY_CLAIMS_ADMIN = '[ApiModul] GetIdentityClaimsAdmin laden';
export const GET_IDENTITY_CLAIMS_ADMIN_AUSFUEHREN = '[ApiModul] GetIdentityClaimsAdmin ausführen';
export const GET_IDENTITY_CLAIMS_ADMIN_ERFOLGREICH = '[ApiModul] GetIdentityClaimsAdmin laden erfolgreich';
export const GET_IDENTITY_CLAIMS_ADMIN_FEHLER = '[ApiModul] GetIdentityClaimsAdmin Ladefehler';
export const GET_IDENTITY_CLAIMS_ADMIN_NICHT_AUSGEFUEHRT = '[ApiModul] GetIdentityClaimsAdmin nicht ausgeführt (evtl. Offline)';


export class GetIdentityClaimsAdminAction implements Action {
    readonly type = GET_IDENTITY_CLAIMS_ADMIN;
        constructor(public optPayload: any = null) {}
    }
export class GetIdentityClaimsAdminAusfuehrenAction implements Action {
    readonly type = GET_IDENTITY_CLAIMS_ADMIN_AUSFUEHREN;
        constructor(public optPayload: any = null) {}
    }
export class GetIdentityClaimsAdminErfolgreichAction implements Action {
    readonly type = GET_IDENTITY_CLAIMS_ADMIN_ERFOLGREICH;
        constructor(public payload: Array<api.KeyValueItem>, public optPayload: any = null) {}
    }
export class GetIdentityClaimsAdminFehlerAction implements Action {
    readonly type = GET_IDENTITY_CLAIMS_ADMIN_FEHLER;
        constructor(public payload: any, public optPayload: any = null) {}
    }
export class GetIdentityClaimsAdminNichtAusgefuehrtAction implements Action {
    readonly type = GET_IDENTITY_CLAIMS_ADMIN_NICHT_AUSGEFUEHRT;
        constructor(public optPayload: any = null) {}
    }
    

export type ApiQueryIdentityClaimsAdminActions =
    GetIdentityClaimsAdminAction
    | GetIdentityClaimsAdminAusfuehrenAction
    | GetIdentityClaimsAdminErfolgreichAction
    | GetIdentityClaimsAdminFehlerAction
    | GetIdentityClaimsAdminNichtAusgefuehrtAction
    ;
